import { render, staticRenderFns } from "./BrowserCheck.vue?vue&type=template&id=0b84d459&scoped=true&"
import script from "./BrowserCheck.vue?vue&type=script&lang=js&"
export * from "./BrowserCheck.vue?vue&type=script&lang=js&"
import style0 from "./BrowserCheck.vue?vue&type=style&index=0&id=0b84d459&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b84d459",
  null
  
)

export default component.exports